import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React from 'react';
import { ThreeDetailedFeatures } from '../ThreeDetailedFeatures/index.js';

// import { relative } from 'path';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var SixDetailedFeatures = function (_a) {
    var items = _a.items, baseProps = __rest(_a, ["items"]);
    return React.createElement(ThreeDetailedFeatures, __assign({ items: items }, baseProps));
};

export { SixDetailedFeatures };
//# sourceMappingURL=index.js.map
